import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';
import { iconAlignTopSvg, iconAlignCenterSvg, iconAlignBottomSvg } from '../../assets/images';

const VerticalAlignment = (props: WidgetProps) => {
    const { label, onChange } = props;
    const [isSelected, setSelected] = useState<string>('');

    const handleVerticalChange = (value: string) => (_event: React.MouseEvent) => {
        setSelected(value);
        onChange(value);
    };

    return (
        <div className="vertical-alignment">
            <label id="color-picker-label">{label}</label>
            <img
                className={`vertical-icon ${isSelected === 'top' ? 'selected-icon' : ''}`}
                id={'vertical-top'}
                src={iconAlignTopSvg}
                alt="vertical-icon-top"
                onClick={handleVerticalChange('top')}
            />
            <img
                className={`vertical-icon ${isSelected === 'center' ? 'selected-icon' : ''}`}
                id={'vertical-center'}
                src={iconAlignCenterSvg}
                alt="toggle-icon-center"
                onClick={handleVerticalChange('center')}
            />
            <img
                className={`vertical-icon ${isSelected === 'bottom' ? 'selected-icon' : ''}`}
                id={'vertical-bottom'}
                src={iconAlignBottomSvg}
                alt="toggle-icon-bottom"
                onClick={handleVerticalChange('bottom')}
            />
        </div>
    );
};

export default VerticalAlignment;
